import { render, staticRenderFns } from "./VeJwCjZhiyeModal.vue?vue&type=template&id=1d36e8e9"
import script from "./VeJwCjZhiyeModal.vue?vue&type=script&lang=js"
export * from "./VeJwCjZhiyeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports